export const LAYCAN_TYPES = [
    {
        key: 'layCan',
        value: 'Laycan',
    },
    {
        key: 'shipmentDates',
        value: 'Shipment dates',
    },
    {
        key: 'shipmentDatesAbout',
        value: 'Shipment dates (abt)',
    },
    {
        key: 'readinessDates',
        value: 'Readiness dates',
    },
];



// WEBPACK FOOTER //
// ./app/constants/layCan.js